export enum ConnectionStatusEnum {
    disconnected = 1,
    online = 2,
    offline = 3,
}
